<div class="map">
  <ng-container *ngIf="mapLoading$ | async; else GoogleMap">
    <ng-content select="[xLoader]"></ng-content>
  </ng-container>

  <ng-template #GoogleMap>
    <google-map
      #mapControl
      width="100%"
      height="100%"
      [options]="mapOptions"
      (mapInitialized)="mapInit()"
    >
      <!-- address markers -->
      <map-marker
        *ngIf="_addressMarker as marker"
        [options]="{
          draggable: dragMarker,
          icon: {
            scaledSize: $any({
              width: mapThemeConfig.markerIconUser.size.width,
              height: mapThemeConfig.markerIconUser.size.height
            }),
            url: mapThemeConfig.markerIconUser.url
          }
        }"
        [position]="marker"
        (mapDragend)="markerDragEnd($event)"
      ></map-marker>

      <!-- input markers-->
      <map-marker *ngFor="let marker of _markers" [options]="marker"></map-marker>

      <!-- input polygons-->
      <map-polygon *ngFor="let poly of _polygons" [options]="poly"></map-polygon>
    </google-map>
  </ng-template>
</div>
